
import Layout from '../../layout/Layout';

import { IconChevronDown, IconDropletHalf2Filled } from '@tabler/icons-react';
import _debounce from 'lodash/debounce';
import QRCodeStyling from 'qr-code-styling';
import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { imageUploadApi, postApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';
import "./Components/CreateQR.css";
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller';

const CustomizeQR = () => {
    const [codeColorDropDown, setCodeColorDropDown] = useState(false);
    const [backgroundColorDropDown, setBackgroundColorDropDown] = useState(false);
    const imageInputRef = useRef(null);
    const { state } = useLocation();
    const navigate = useNavigate();

    const patterns = [
        {
            id: 1,
            name: 'rounded',
            image: process.env.PUBLIC_URL + "/images/qr/rounded.png",
        }, {
            id: 2,
            name: 'dots',
            image: process.env.PUBLIC_URL + "/images/qr/dots.png",
        }, {
            id: 3,
            name: 'classy',
            image: process.env.PUBLIC_URL + "/images/qr/classy.png",
        }, {
            id: 4,
            name: 'classy-rounded',
            image: process.env.PUBLIC_URL + "/images/qr/classy-rounded.png",
        }, {
            id: 5,
            name: 'square',
            image: process.env.PUBLIC_URL + "/images/qr/square.png",
        }, {
            id: 6,
            name: 'extra-rounded',
            image: process.env.PUBLIC_URL + "/images/qr/extra-rounded.png",
        }
    ]

    const [selectedPattern, setSelectedPattern] = useState('rounded');

    const cornerPatterns = [
        {
            id: 1,
            name: 'dots',
            image: process.env.PUBLIC_URL + "/images/qr/corner-dot.png",
        }, {
            id: 2,
            name: 'square',
            image: process.env.PUBLIC_URL + "/images/qr/corner-square.png",
        }, {
            id: 3,
            name: 'extra-rounded',
            image: process.env.PUBLIC_URL + "/images/qr/corner-extra-rounded.png",
        }
    ]

    const [selectedCornerPattern, setSelectedCornerPattern] = useState('dots');

    const presets = [
        {
            id: 1,
            colors: ['#000000', '#00000080']
        }, {
            id: 2,
            colors: ['#DE3121', '#DE312180']
        }, {
            id: 3,
            colors: ['#EF8000', '#EF800080']
        }, {
            id: 4,
            colors: ['#198639', '#19863980']
        }, {
            id: 5,
            colors: ['#229CE0', '#229CE080']
        }, {
            id: 6,
            colors: ['#2A5BD7', '#2A5BD780']
        }, {
            id: 7,
            colors: ['#6B52D1', '#6B52D180']
        }, {
            id: 8,
            colors: ['#D84280', '#D8428080']
        }
    ]

    const [fileExt, setFileExt] = useState("svg");
    const ref = useRef(null);
    const [matchQrWithCorner, setMatchQrWithCorner] = useState(false);

    const [options, setOptions] = useState({
        width: 200,
        height: 200,
        type: 'svg',
        data: 'https://app.advy.me/',
        image: '',
        margin: 10,
        qrOptions: {
            typeNumber: 0,
            mode: 'Byte',
            errorCorrectionLevel: 'Q'
        },
        imageOptions: {
            hideBackgroundDots: true,
            imageSize: 0.5,
            margin: 5,
            crossOrigin: 'anonymous',
        },
        dotsOptions: {
            color: '#000',
            type: 'rounded'
        },
        backgroundOptions: {
            color: '#fff',
        },
        cornersSquareOptions: {
            color: '#222222',
            type: 'extra-rounded',
        },
        cornersDotOptions: {
            color: '#222222',
            type: 'dot',
        }
    });

    const [qrCode] = useState(new QRCodeStyling(options));

    useEffect(() => {
        if (ref.current) {
            qrCode.append(ref.current);
        }
    }, [qrCode, ref, options]);

    useEffect(() => {
        if (!qrCode) return;
        qrCode.update(options);
    }, [qrCode, options]);

    async function shortenUrl() {
        loadingShow();
        if (state?.data) {
            let local = { ...options };
            local.data = state?.data;
            setOptions(local);

            setTimeout(() => {
                qrCode.getRawData().then(async (data) => {
                    let imageLink = await uploadQr(data);
                    let postData = {
                        qrLink: imageLink.data,
                        shortLink: state?.data
                    }
                    let resp2 = await postApi(postData, urlApi.createQr);
                    navigate("/qr-codes", {
                        replace: true
                    });
                    loadingHide();
                    if (resp2.responseCode === 200) {
                        toast.success(resp2.message);
                    } else {
                        toast.error(resp2.message);
                    }
                });
            }, 1000);
        } else {
            toast.error('Error Occurred while customizing QR code');
            loadingHide();
            return;
        }
    }


    // const onLinkChange = (e) => {
    //     let local = { ...options };
    //     local.data = e.target.value;
    //     setOptions(local);
    // }

    // DOT OPTION COLOR CHANGES START
    const handleDotOptionChange = (option) => {
        setSelectedPattern(option);
        setOptions(options => ({
            ...options,
            dotsOptions: {
                ...options.dotsOptions,
                type: option
            }
        }));
    }

    const handleCodeColorTypeChange = (e) => {
        let local = { ...options };
        if (e == "SINGLE") {
            local.dotsOptions.gradient = null
            local.dotsOptions.color = '#000';
            if (matchQrWithCorner) {
                local.cornersSquareOptions.color = local.dotsOptions.color;
                local.cornersSquareOptions.gradient = local.dotsOptions.gradient;
                local.cornersDotOptions.color = local.dotsOptions.color;
                local.cornersDotOptions.gradient = local.dotsOptions.gradient;
            }
        }
        if (e == "GRADIENT") {
            local.dotsOptions.color = null;
            local.dotsOptions.gradient = {
                type: 'linear',
                rotation: 0,
                colorStops: [{ offset: 0, color: '#D84280' }, { offset: 1, color: '#229CE0' }]
            };
            if (matchQrWithCorner) {
                local.cornersSquareOptions.color = local.dotsOptions.color;
                local.cornersSquareOptions.gradient = local.dotsOptions.gradient;
                local.cornersDotOptions.color = local.dotsOptions.color;
                local.cornersDotOptions.gradient = local.dotsOptions.gradient;
            }
        }
        setCodeColorDropDown(false);
        setOptions(local);
    }

    const handleDotsGradientTypeChange = (e) => {
        let local = { ...options };
        local.dotsOptions.gradient.type = e.target.value;
        if (matchQrWithCorner) {
            local.cornersSquareOptions.color = local.dotsOptions.color;
            local.cornersSquareOptions.gradient = local.dotsOptions.gradient;
            local.cornersDotOptions.color = local.dotsOptions.color;
            local.cornersDotOptions.gradient = local.dotsOptions.gradient;
        }
        setOptions(local);
    }

    const handleDotsGradientColorChange = (position, color) => {
        let local = { ...options };
        local.dotsOptions.gradient.colorStops[position].color = color;
        if (matchQrWithCorner) {
            local.cornersSquareOptions.color = local.dotsOptions.color;
            local.cornersSquareOptions.gradient = local.dotsOptions.gradient;
            local.cornersDotOptions.color = local.dotsOptions.color;
            local.cornersDotOptions.gradient = local.dotsOptions.gradient;
        }
        setOptions(local);
    }

    const handleDotGradientRotationChange = (e) => {
        let local = { ...options };
        local.dotsOptions.gradient.rotation = e.target.value;
        setOptions(local);
    }

    const handleDotsColorChange = (color) => {
        let local = { ...options };
        local.dotsOptions.color = color;
        // if (local.dotsOptions?.gradient?.colorStops) {
        //     delete local.dotsOptions.gradient;
        // }
        if (matchQrWithCorner) {
            local.cornersSquareOptions.color = local.dotsOptions.color;
            local.cornersSquareOptions.gradient = local.dotsOptions.gradient;
            local.cornersDotOptions.color = local.dotsOptions.color;
            local.cornersDotOptions.gradient = local.dotsOptions.gradient;
        }
        setOptions(local);
    }
    // DOT OPTION COLOR CHANGES END

    const handleCornerOptionChange = (option) => {
        setSelectedCornerPattern(option);
        setOptions(options => ({
            ...options,
            cornersSquareOptions: {
                ...options.cornersSquareOptions,
                type: option
            }
        }));
    }

    // BACKGROUND OPTION COLOR CHANGES START
    const handleBackgroundColorTypeChange = (e) => {
        let local = { ...options };
        if (e == "SINGLE") {
            local.backgroundOptions.gradient = null
            local.backgroundOptions.color = '#fff';
        }
        if (e == "GRADIENT") {
            local.backgroundOptions.color = null;
            local.backgroundOptions.gradient = {
                type: 'linear',
                rotation: 0,
                colorStops: [{ offset: 0, color: '#ffffff' }, { offset: 1, color: '#dedede' }]
            };
        }
        setBackgroundColorDropDown(false);
        setOptions(local);
    }

    const handleBackgroundGradientTypeChange = (e) => {
        let local = { ...options };
        local.backgroundOptions.gradient.type = e.target.value;
        setOptions(local);
    }

    const handleBackgroundGradientColorChange = (position, color) => {
        let local = { ...options };
        local.backgroundOptions.gradient.colorStops[position].color = color;
        setOptions(local);
    }

    const handleBackgroundGradientRotationChange = (e) => {
        let local = { ...options };
        local.backgroundOptions.gradient.rotation = e.target.value;
        setOptions(local);
    }

    const handleBackgroundColorChange = (color) => {
        setOptions(options => ({
            ...options,
            backgroundOptions: {
                color
            }
        }));
    }
    // BACKGROUND OPTION COLOR CHANGES END

    const handleImageOnChange = (e) => {
        const file = e.target.files[0];
        const maxSizeInBytes = 1024 * 1024 * 5;
        if (file && file.size > maxSizeInBytes) {
            toast.error('File size exceeds the limit of 5MB.');
            e.target.value = null;
        } else {
            let local = { ...options };
            local.image = URL.createObjectURL(file);
            setOptions(local);
        }
    }

    const handleRemoveImage = () => {
        setOptions(options => ({
            ...options,
            image: null
        }));
    }

    const toggleMatchQRCorner = () => {
        // match same color coordinations as dots color
        let local = { ...options };
        if (!matchQrWithCorner) {
            local.cornersSquareOptions.color = local.dotsOptions.color;
            local.cornersSquareOptions.gradient = local.dotsOptions.gradient;
            local.cornersDotOptions.color = local.dotsOptions.color;
            local.cornersDotOptions.gradient = local.dotsOptions.gradient;
            setOptions(local);
            setMatchQrWithCorner(true)
        } else {
            local.cornersSquareOptions.color = '#222222';
            local.cornersSquareOptions.gradient = null;
            local.cornersDotOptions.color = '#222222';
            local.cornersDotOptions.gradient = null;
            setOptions(local);
            setMatchQrWithCorner(false)
        }
    };

    const onExtensionChange = (event) => {
        setFileExt(event.target.value);
    };

    async function uploadQr(data) {
        const formData = new FormData();
        const blob = new Blob([data], { type: 'image/png' });
        formData.append('name', 'image/png');
        formData.append('image', data);

        let resp = await imageUploadApi(formData, urlApi.imageUploadApi + "?folder=qr");

        if (resp.responseCode === 200) {
            return resp;
        } else {
            toast.error(resp.message);
            return;
        }
    }

    const onDownloadClick = () => {
        if (!qrCode) return;
        // qrCode.download({
        //     extension: fileExt
        // });

        shortenUrl();

    };

    useEffect(() => {

        const handlePopState = (event) => {
            event.preventDefault();
            onDownloadClick();

        };
        window.addEventListener("popstate", handlePopState);
        window.history.pushState({ modalOpened: false }, "");

        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, []);

    return (
        <Layout>
            <div className="grid grid-cols-1 md:grid-cols-3">
                <div className="col-span-2">
                    <div>

                        <div className="flex justify-between mb-3">
                            <div className='block'>
                                <p className='mb-2 text-lg font-semibold'>Select a style</p>
                                <p className='mb-2 font-semibold text-sm'>Patterns</p>
                                <div className="flex flex-wrap gap-3 mb-3">
                                    {patterns.map((item) => {
                                        return (
                                            <div key={item?.id} title={item?.name} className='flex flex-col items-center gap-2 cursor-pointer' onClick={() => handleDotOptionChange(item?.name)}>
                                                <img src={item?.image} alt="" className={`outline outline-1 h-14
                                                         p-2 rounded-md ${selectedPattern == item.name ? 'outline-primary' : 'outline-[#DBE0EB]'}`} />
                                                {/* <p>{item?.name}</p> */}
                                            </div>)
                                    })
                                    }
                                </div>
                                <p className='mb-2 font-semibold text-sm'>Corners</p>
                                <div className="flex gap-3">
                                    {cornerPatterns.map((item) => {
                                        return (
                                            <div key={item?.id} className='flex gap-2 cursor-pointer' onClick={() => handleCornerOptionChange(item?.name)}>
                                                <img src={item?.image} alt="" className={`outline outline-1 p-2 rounded-md ${selectedCornerPattern == item.name ? 'outline-primary' : 'outline-[#DBE0EB]'}`} />
                                            </div>)
                                    })
                                    }
                                </div>
                            </div>
                        </div>

                        <div>
                            <p className='mb-2 text-lg font-semibold'>Choose Your Colors</p>
                            <p className='mb-2 font-semibold text-sm'>Preset</p>
                            <div className='flex flex-wrap gap-3 mb-4'>

                                {
                                    presets.map((item) => {
                                        return (
                                            <div key={item?.id} className={`p-1 rounded-full ${options.dotsOptions.color == item?.colors[0] && 'outline outline-2 outline-primary'}`}>
                                                <div className={`h-8 aspect-square cursor-pointer rounded-full`} style={{ background: `linear-gradient( to bottom, ${item.colors[0]} , ${item.colors[1]})` }} onClick={() => handleDotsColorChange(item?.colors[0])}>  </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>

                            <div className='flex flex-wrap items-center mb-4 gap-3'>
                                <div>
                                    <p className='mb-2 font-semibold text-sm'>Code</p>

                                    <div className='relative w-max'>
                                        <div className="flex outline outline-1 outline-[#0000000D] p-2 w-max rounded-lg gap-5 items-center max-w-[300px] cursor-pointer" onClick={() => setCodeColorDropDown(prev => !prev)}>
                                            <IconDropletHalf2Filled size={16} />
                                            <p className="mb-0 text-sm">{options.dotsOptions.color ? 'Single Color' : options.dotsOptions.gradient ? 'Gradient' : 'Choose Color'}</p>
                                            <IconChevronDown size={16} />
                                        </div>
                                        <div className={`absolute bg-white w-full text-center py-2 shadow rounded-b-lg flex flex-col gap-2 text-sm transition-all ${codeColorDropDown ? 'z-[30] h-max' : ' -z-10 h-0 hidden'}`}>
                                            <p className={`mb-0 hover:bg-slate-50 cursor-pointer ${options.dotsOptions.color && 'text-primary'} `} onClick={() => handleCodeColorTypeChange("SINGLE")}>Single Color</p>
                                            <p className={`mb-0 hover:bg-slate-50 cursor-pointer ${options.dotsOptions.gradient && 'text-primary'} `} onClick={() => handleCodeColorTypeChange("GRADIENT")}>Gradient</p>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <p className='mb-2 font-semibold text-sm'>{options.dotsOptions.color ? 'Hex Value' : options.dotsOptions.gradient ? 'Gradient Colors' : ''}</p>
                                    {
                                        options.dotsOptions.gradient ? (
                                            <div className='flex gap-3'>
                                                <div className='flex gap-2'>
                                                    <select name="gradient-type" id="" onChange={handleDotsGradientTypeChange}>
                                                        <option value="linear">Linear</option>
                                                        <option value="radial">Radial</option>
                                                    </select>
                                                    {options.dotsOptions.gradient.type == "linear" && <label htmlFor="range">Rotation</label>}
                                                    {options.dotsOptions.gradient.type == "linear" && <input type="range" name="" id="range" min={0} max={360} placeholder='Rotation' onChange={handleDotGradientRotationChange} />
                                                    }
                                                    <input type='color' className='!border-2 rounded-md shadow-md' defaultValue={options?.dotsOptions?.gradient?.colorStops[0]?.color} key={options?.dotsOptions?.gradient?.colorStops[0]?.color ?? 'g-key-1'} onChange={_debounce((e) => handleDotsGradientColorChange(0, e.target.value), 300)} />
                                                    <input type='color' className='!border-2 rounded-md shadow-md' defaultValue={options.dotsOptions.gradient.colorStops[1].color} key={options.dotsOptions.gradient.colorStops[1].color || 'g-key-2'} onChange={_debounce((e) => handleDotsGradientColorChange(1, e.target.value), 300)} />
                                                </div>
                                            </div>
                                        )
                                            : <div className='flex'>
                                                <input type="color" className='h-8 w-8 rounded-s-lg outline-none border-none focus:outline-none focus:border-none' name="" id="" onChange={_debounce((e) => handleDotsColorChange(e.target.value), 300)} defaultValue={options.dotsOptions.color} key={options.dotsOptions.color} />
                                                <input type="text" className='text-black rounded-e-lg bg-[#E8EBF2] p-1 text-sm focus:outline-none' name="" id="" onChange={(e) => handleDotsColorChange(e.target.value)} defaultValue={options.dotsOptions.color} key={'code-' + options.dotsOptions.color} />
                                            </div>
                                    }
                                </div>
                            </div>

                            <div className='flex flex-wrap items-center mb-4 gap-3'>

                                <div>
                                    <p className='mb-2 font-semibold text-sm'>Background</p>

                                    <div className='relative w-max'>
                                        <div className="flex outline outline-1 outline-[#0000000D] p-2 w-max rounded-lg gap-5 items-center max-w-[300px] cursor-pointer" onClick={() => setBackgroundColorDropDown(prev => !prev)}>
                                            <IconDropletHalf2Filled size={16} />
                                            <p className="mb-0 text-sm">{options.backgroundOptions.color ? 'Single Color' : options.backgroundOptions.gradient ? 'Gradient' : 'Choose Color'}</p>
                                            <IconChevronDown size={16} />
                                        </div>
                                        <div className={`absolute bg-white w-full text-center py-2 shadow rounded-b-lg flex flex-col gap-2 text-sm transition-all ${backgroundColorDropDown ? 'z-[30] h-max' : ' -z-10 h-0 hidden'}`}>
                                            <p className={`mb-0 hover:bg-slate-50 cursor-pointer ${options.backgroundOptions.color && 'text-primary'} `} onClick={() => handleBackgroundColorTypeChange("SINGLE")}>Single Color</p>
                                            <p className={`mb-0 hover:bg-slate-50 cursor-pointer ${options.backgroundOptions.gradient && 'text-primary'} `} onClick={() => handleBackgroundColorTypeChange("GRADIENT")}>Gradient</p>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <p className='mb-2 font-semibold text-sm'>{options.backgroundOptions.color ? 'Hex Value' : options.backgroundOptions.gradient ? 'Gradient Colors' : ''}</p>
                                    {
                                        options.backgroundOptions.gradient ? (
                                            <div className='flex gap-3'>
                                                <div className='flex gap-2'>
                                                    <select name="gradient-type" id="" onChange={handleBackgroundGradientTypeChange}>
                                                        <option value="linear">Linear</option>
                                                        <option value="radial">Radial</option>
                                                    </select>
                                                    {options.backgroundOptions.gradient.type == "linear" && <label htmlFor="range">Rotation</label>}
                                                    {options.backgroundOptions.gradient.type == "linear" && <input type="range" name="" id="range" min={0} max={360} placeholder='Rotation' onChange={handleBackgroundGradientRotationChange} />}
                                                    <input type='color' className='!border-2 rounded-md shadow-md' key={options.backgroundOptions.gradient.colorStops[0].color} defaultValue={options.backgroundOptions.gradient.colorStops[0].color} onChange={_debounce((e) => handleBackgroundGradientColorChange(0, e.target.value), 300)} />
                                                    <input type='color' className='!border-2 rounded-md shadow-md' key={options.backgroundOptions.gradient.colorStops[1].color} defaultValue={options.backgroundOptions.gradient.colorStops[1].color} onChange={_debounce((e) => handleBackgroundGradientColorChange(1, e.target.value), 300)} />
                                                </div>
                                            </div>
                                        )
                                            : <div className='flex'>
                                                <input type="color" className='h-8 w-8 rounded-s-lg outline-none border-none focus:outline-none focus:border-none' name="" id="" onChange={_debounce((e) => handleBackgroundColorChange(e.target.value), 300)} defaultValue={options.backgroundOptions.color} key={options.backgroundOptions.color} />
                                                <input type="text" className='text-black rounded-e-lg bg-[#E8EBF2] p-1 text-sm focus:outline-none' name="" id="" onChange={(e) => handleBackgroundColorChange(e.target.value)} defaultValue={options.backgroundOptions.color} key={'bg-' + options.backgroundOptions.color} />
                                            </div>
                                    }
                                </div>


                            </div>
                        </div>

                        <div className='mb-5'>
                            <p className='mb-2 font-semibold text-sm'>Corners</p>
                            <div className='flex gap-3 items-center'>
                                <button className={`matchCornerButton ${matchQrWithCorner ? 'on' : 'off'}`} onClick={toggleMatchQRCorner}>
                                    <span className="pin" />
                                </button> <label htmlFor="range" className='text-sm text-[var(--secondary-text)]'>Use QR Code Color</label>
                            </div>
                        </div>

                        <div>
                            <p className='text-lg font-semibold mb-0'>Add a logo or Image</p>
                            <p className="!mb-3 text-xs text-gray-500">*Maximum Size 5Mb</p>
                            <input type="file" accept="image/*" name="" id="" onChange={handleImageOnChange} className='hidden' ref={imageInputRef} />
                            <div className="flex gap-3 items-center">
                                <div className={`outline outline-1 p-3 cursor-pointer rounded-md ${options.image == null ? 'outline-primary' : 'outline-[#DBE0EB]'}`} onClick={handleRemoveImage}> <img src={process.env.PUBLIC_URL + "/images/qr/close.png"} alt="" /> </div>
                                <div className={`outline outline-1 p-3 cursor-pointer rounded-md ${options.image ? 'outline-primary' : 'outline-[#DBE0EB]'}`} onClick={() => imageInputRef.current.click()}> <img src={process.env.PUBLIC_URL + "/images/qr/add-photo.png"} alt="" /> </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-span-1">
                    <div className='text-center'>
                        <p className='mb-3 text-lg font-semibold '>Preview</p>
                        <div ref={ref} />
                    </div>
                </div>
            </div>

            <hr className='my-3' />
            <div className='flex gap-3 px-4 py-2'>
                <button className='modal-cancel-btn' onClick={() => {
                    onDownloadClick();
                }}>Cancel</button>
                <button className='primary-btn ms-auto' onClick={() => onDownloadClick()}>Create</button>
            </div>
        </Layout>
    )
}

export default CustomizeQR